import { Vue, Component } from 'vue-property-decorator';
import APP_CONST from '@/constants/AppConst';
import LandscapeMode from '@/popupcomponents/landscapemodepopup/LandscapeMode.vue';

@Component({
  components: {
    'landscape-mode': LandscapeMode
  }
})
export default class FooterComponent extends Vue {

  openUrl() {
    window.open(APP_CONST.PRIVACY_POLICY, '_blank');
  }
}